<template>
  <div class="item-standart"
       v-if="showItem"
       @click="itemClick">
    <div class="avatar">
      <child-avatar :child="child"
                     size="small"
                     icon="IconExclamationSign"
                     icon-color="#fff"
                     icon-background-color="#f7c716"
                     :show-status="false" />
    </div>
    <div class="content">
      <div class="description with-info">
        <div class="title">
          {{ $t("viewed", { categories }) }}
        </div>

        <block-warn-info />
      </div>

      <a :href="url"
         class="one-liner"
         v-if="url">
        {{ urlTitle }}
      </a>
      <div class="details">
        <feed-item-details :item="item" />
      </div>
    </div>
  </div>
</template>

<script>
  import ItemBase from './ItemBase.vue'
  import BlockWarnInfo from './BlockWarnInfo.vue'
  import getCategories from '@/services/categories.js'
  import analytics from '@/services/analytics.js'

  import { getDomain } from '@/services/utils.js'

  export default {
    extends: ItemBase,

    props: {
      item: {
        required: true,
        type: Object
      }
    },

    components: {
      BlockWarnInfo,
    },

    methods: {
      itemClick() {
        analytics.sendEvent('Pk_Alert_Feed')
      },

      ...mapGetters('categories', {
        getCategoryById: 'getById'
      })
    },

    computed: {
      ...mapGetters('children', {
        getChildById: 'getById'
      }),

      child() {
        return this.getChildById(this.item.user_id)
      },

      showItem() {
        return this.child
      },

      categories() {
        return getCategories(
          this.item.details.category_ids,
          this.commonCategories,
          this.customCategories
        )
      },

      url() {
        if (this.item.details.url) {
          return this.item.details.url
        } else if (this.item.details.flagged_url) {
          return this.item.details.flagged_url
        }

        return null
      },

      urlTitle() {
        if (this.item.details.url) {
          return getDomain(this.item.details.url)
        } else if (this.ites.details.flagged_url) {
          return getDomain(this.items.details.flagged_url)
        }

        return null
      },

      ...mapGetters('categories', {
        commonCategories: 'get',
        customCategories: 'getCustom'
      }),
    }
  }
</script>

<style lang="scss" scoped>
  .with-info {
    position: relative;
    padding-right: 30px;
  }
</style>
